import(/* webpackMode: "eager" */ "/var/www/vhosts/adminphumoi.phucbaokhang.com.vn/httpdocs/app/src/app/error.tsx");
